export default __webpack_public_path__ + "static/media/load-unpacked.a2ad3eb4.webp";